<div style="position: relative; /* or absolute */
top: 0%;
left: 1%;
width: 97%;">
    @if (isEditingExistingGroup) {
        <h2>{{ 'PORTAL.GROUP_EDIT' | translate:{name: group.label} }}</h2>
    } @else {
        <h2>{{ 'PORTAL.GROUP_ADD' | translate }}</h2>
    }

    @if (error) {
        <div class="alert alert-danger">{{error}}</div>
    }

    <div class="col-xs-12">
        <div [hidden]="submitted">
            <form (ngSubmit)="onSubmit()" #groupForm="ngForm">
                <button type="submit" class="btn btn-primary" style="float: right;" [disabled]="!groupForm.form.valid">{{'FUNCTION-BUTTONS.SAVE' | translate}}
                </button>
                <button class="btn btn-primary" style="float: right; margin-right: 10px;" (click)="goToList()">{{'FUNCTION-BUTTONS.CANCEL' | translate}}</button>

                <br/>
                <br/><br/>
                <div class="form-group">
                    <label for="groupLabel">{{'PORTAL.GROUP_LABEL' | translate}}</label>
                    <input type="text" class="form-control" id="groupLabel" [(ngModel)]="group.label" name="groupLabel" #groupLabel="ngModel" required>
                    <div [hidden]="groupLabel.valid || groupLabel.pristine" class="alert alert-danger">
                        {{'PORTAL.GROUP_NAME_REQUIRED' | translate}}
                    </div>
                </div>

                <div class="form-group">
                    <label for="groupKey">{{'PORTAL.GROUP_KEY' | translate}}</label>
                    <input type="text" class="form-control" id="groupKey" [value]="keyPreview()" readonly>
                    <small class="form-text text-muted">{{'PORTAL.GROUP_KEY_HINT' | translate}}</small>
                </div>

                <div class="form-group">
                    <label for="groupDesc">{{'PORTAL.GROUP_DESCRIPTION' | translate}}</label>
                    <textarea class="form-control" id="groupDesc" rows="3" [(ngModel)]="group.description" name="groupDesc"></textarea>
                </div>

                <div class="form-group">
                    <label for="groupSort">{{'PORTAL.GROUP_SORT_ORDER' | translate}}</label>
                    <input type="number" class="form-control" id="groupSort" [(ngModel)]="group.sortOrder" name="groupSort">
                </div>
            </form>
        </div>
    </div>
</div>
